import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ModelIndicatorsService {
  constructor(private http: HttpClient) {}

  public load(teamName: string): Observable<any> {
    return this.http.get(`${ConfigService.apiUrl}/model-indicators/${teamName}`);
  }
}
